const TIME_LOG_ENTRY_TYPES = [
  { value: 'overtime', label: 'Arbejde uden for normtid' },
  { value: 'holiday', label: 'Ferie' },
  { value: 'sickLeave', label: 'Sygdom' },
  { value: 'timeOff', label: 'Fri' },
  { value: 'work', label: 'Arbejdstid' },
];

export default TIME_LOG_ENTRY_TYPES;
